import countdownTimer from '../../components/countdownTimer/countdownTimer';

const tileGridInit = () => {
    const tileGrids = document.querySelectorAll('.s-tile-grid');
    tileGrids.forEach(tileGrid => {
        /**
         * @type {HTMLElement}
         */
        const countdownEl = tileGrid.querySelector('[data-countdown-timer]');
        if (countdownEl) {
            try {
                const { countdownTimer: endDateString } = countdownEl.dataset;
                const spanSr = document.createElement('span');
                const spanSrText = document.createTextNode('Time remaining:');
                const spanTimer = document.createElement('span');
                const para = document.createElement('p');
                spanSr.classList.add('sr-only');
                spanSr.appendChild(spanSrText);
                spanTimer.classList.add('tile-grid-countdown-text');
                para.appendChild(spanSr);
                para.appendChild(spanTimer);
                countdownEl.appendChild(para);
                const runCb = (dd, hh, mm, ss) => {
                    const toStringWithZero = num =>
                        `${num < 10 ? '0' : ''}${num}`;
                    const day = toStringWithZero(dd);
                    const hour = toStringWithZero(hh);
                    const minute = toStringWithZero(mm);
                    const second = toStringWithZero(ss);
                    const timerString = `${
                        day > 0 ? `${day}:` : ''
                    }${hour}:${minute}:${second}`;
                    spanTimer.textContent = timerString;
                };
                const clearCb = () => {
                    countdownEl.removeChild(para);
                    countdownEl.style.display = 'none';
                };
                countdownTimer(endDateString, runCb, clearCb);
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
            }
        }
    });
};

document.addEventListener('DOMContentLoaded', tileGridInit);
